import React from 'react'
import PropTypes from 'prop-types'
import './features19.css'

const Features19 = (props) => {
  return (
    <div className="features19-layout thq-section-padding">
      <div className="features19-max-width thq-section-max-width">
        <div className="features19-image-container">
          <img
            alt={props.feature1ImageAlt}
            src={props.feature1ImageSrc}
            className="thq-img-ratio-16-9"
          />
        </div>
        <div className="features19-content">
          <div className="features19-section-title">
            <div className="features19-content-wrapper">
              <h2 className="features19-title thq-heading-2">
                {props.feature1Title ?? "Commonwealth AI Incubator"}
              </h2>
              <p className="features19-description thq-body-large">
                {props.feature1Description ?? 
                  "The Commonwealth Secretariat and SAS have launched an innovative initiative to empower learners and educators in Commonwealth countries by providing access to SAS Viya, a cloud-based platform on Microsoft Azure. This initiative equips users with cutting-edge tools for AI and data analytics, fostering the development of critical skills in visual analytics, model management, and open-source integration. Participants will also gain practical experience through educational resources and international AI competitions, with a strong focus on promoting responsible and ethical use of AI and data analytics."
                }
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Features19.defaultProps = {
  feature1Description: undefined,
  feature1ImageAlt: 'Image depicting AI incubator',
  feature1Title: undefined,
  feature1ImageSrc:
    'https://production-new-commonwealth-files.s3.eu-west-2.amazonaws.com/s3fs-public/2024-08/article-image.jpg?VersionId=mgABqcPR41c_1eRFkA8pprb0i9FZqVTa',
}

Features19.propTypes = {
  feature1Description: PropTypes.string,
  feature1ImageAlt: PropTypes.string,
  feature1Title: PropTypes.string,
  feature1ImageSrc: PropTypes.string,
}

export default Features19
